namespace Matrix.Data {
    export interface ListItemRow {
        ListCode?: string;
        ListItemCode?: string;
        ListItemText?: string;
        DefaultSortOrder?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace ListItemRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'ListItemText';
        export const localTextPrefix = 'Data.ListItem';
        export const lookupKey = 'Data.ListItem';

        export function getLookup(): Q.Lookup<ListItemRow> {
            return Q.getLookup<ListItemRow>('Data.ListItem');
        }
        export const deletePermission = 'DataAdmin:List';
        export const insertPermission = 'DataAdmin:List';
        export const readPermission = 'Read:List';
        export const updatePermission = 'DataAdmin:List';

        export declare const enum Fields {
            ListCode = "ListCode",
            ListItemCode = "ListItemCode",
            ListItemText = "ListItemText",
            DefaultSortOrder = "DefaultSortOrder",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
